import { useState } from "react";

/**
 * Holds submit on the last step until the timing token field reports it is
 * ready. The field only reports from an effect, so arriving on the last step
 * resets readiness during render; otherwise the first render there would
 * read the previous visit's ready state.
 */
function useTimingTokenGate(isLastStep: boolean) {
  const [isTimingTokenReady, setIsTimingTokenReady] = useState(false);
  const [wasLastStep, setWasLastStep] = useState(isLastStep);
  if (wasLastStep !== isLastStep) {
    setWasLastStep(isLastStep);
    if (isLastStep) {
      setIsTimingTokenReady(false);
    }
  }

  return {
    isAwaitingTimingToken: isLastStep && !isTimingTokenReady,
    onTimingTokenReadyChange: setIsTimingTokenReady,
  };
}

export { useTimingTokenGate };
